import React, { useRef, useState } from 'react';
import { ui, tabStyle } from './ui';
import PaperPreview from './PaperPreview';
import { PAGE_H_PX } from './previewStyles';
import { downloadSheetPdf, printSheet, safeFileName } from '../AIPaper/exportUtils';

// Right-hand live A4 canvas + export buttons. Both the paper and the answer key are always
// mounted (one visible, one off-screen) so either PDF can be exported from any tab.
export default function PreviewPane({ paper, onError }) {
  const [keyMode, setKeyMode] = useState(false);
  const [guides, setGuides] = useState(true);
  const paperRef = useRef(null);
  const keyRef = useRef(null);
  const base = safeFileName(paper.title || 'Question_Paper');

  const run = async (fn) => { try { await fn(); } catch (e) { onError(e.message || 'Export failed'); } };
  const visibleRef = keyMode ? keyRef : paperRef;

  return (
    <div style={{ flex: '1 1 460px', minWidth: 0, height: '100%', minHeight: 0, background: '#475569', overflow: 'auto', overscrollBehavior: 'contain', padding: 12 }}>
      <div style={{ ...ui.row, marginBottom: 8, background: '#fff', padding: 6, borderRadius: 8 }}>
        <button type="button" style={tabStyle(!keyMode)} onClick={() => setKeyMode(false)}>Question Paper</button>
        <button type="button" style={tabStyle(keyMode)} onClick={() => setKeyMode(true)}>Answer Key</button>
        <label style={{ fontSize: 11 }}><input type="checkbox" checked={guides} onChange={(e) => setGuides(e.target.checked)} /> A4 page guides</label>
        <button type="button" style={{ ...ui.btn, marginLeft: 'auto' }} onClick={() => run(() => downloadSheetPdf(paperRef.current, `${base}.pdf`))}>⬇ Paper PDF</button>
        <button type="button" style={ui.btn} onClick={() => run(() => downloadSheetPdf(keyRef.current, `${base}_AnswerKey.pdf`))}>🔒 Answer Key PDF</button>
        <button type="button" style={ui.btn} onClick={() => run(() => printSheet(visibleRef.current, paper.title || 'Question Paper'))}>🖨 Print</button>
      </div>
      <div style={{ overflow: 'auto' }}>
        <div style={{ position: 'relative', boxShadow: '0 4px 18px rgba(0,0,0,.4)', width: 'fit-content', margin: '0 auto', padding: '12mm', background: '#fff' }}>
          <div style={{ display: keyMode ? 'none' : 'block' }}><PaperPreview ref={paperRef} paper={paper} /></div>
          <div style={{ display: keyMode ? 'block' : 'none' }}><PaperPreview ref={keyRef} paper={paper} keyMode /></div>
          {/* Guides are an overlay OUTSIDE the exported sheet, so they never appear in PDF/print */}
          {guides && (
            <div aria-hidden="true" style={{
              position: 'absolute', left: 0, right: 0, top: '12mm', bottom: 0, pointerEvents: 'none',
              backgroundImage: `repeating-linear-gradient(to bottom, transparent 0, transparent ${PAGE_H_PX - 2}px, #ef4444 ${PAGE_H_PX - 2}px, #ef4444 ${PAGE_H_PX}px)`
            }} />
          )}
        </div>
      </div>
    </div>
  );
}
